<template>
  <el-form
    :model="addForm"
    ref="addForm"
    :rules="rules"
    label-width="120px"
    :hide-required-asterisk="false"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label="所属条线" prop="line" key="1">
          <el-select
            v-model="addForm.line"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择所属条线"
            @change="handleChangeTx"
          >
            <el-option
              v-for="item in txList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24" v-if="bmShowFlag">
        <el-form-item label="所属项目" prop="xmbh" key="3">
          <el-select
            v-model="addForm.xmbh"
            filterable
            clearable
            style="width: 100%"
            placeholder="请选择所属项目"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmzt + '-' + item.xmjc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="产品版本" prop="productVersion" key="6">
          <el-input
            show-word-limit
            placeholder="如：V1.6.3"
            v-model="addForm.productVersion"
            maxlength="20"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="标题" prop="title" key="6">
          <el-input
            show-word-limit
            placeholder="请输入任务标题"
            maxlength="100"
            v-model="addForm.title"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="问题类型" prop="sort" key="3">
          <el-select
            v-model="addForm.sort"
            filterable
            style="width: 100%"
            placeholder="请选择问题类型"
          >
            <el-option
              v-for="(item, index) in sortList"
              :key="index"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-row>
          <el-col :span="12">
            <el-form-item label="期望完成时间" prop="finishTime" key="10">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="addForm.finishTime"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划工时(天)" prop="planTime" key="11">
              <el-input-number
                :min="0"
                :max="99999"
                label="描述文字"
                v-model="addForm.planTime"
              >
                <template slot="append"></template>
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-form-item label="指派给" prop="designee" key="8">
          <treeselect
            v-model="addForm.designee"
            placeholder="请选择员工"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 100%"
            size="small"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24" style="position: relative">
        <span class="star">*</span>
        <el-form-item label="详细描述" prop="detail" key="8">
          <span>
            <div id="wangEditor"></div>
          </span>
        </el-form-item>
      </el-col>
      <el-col :span="24" key="9">
        <el-form-item label="解决方案" prop="jjfa">
          <div id="wangEditor2"></div>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-row>
          <el-col :span="24">
            <el-form-item label="任务模板附件" key="12">
              <el-upload
                action="#"
                class="upload-demo"
                ref="upload"
                :headers="headers"
                :on-change="handleChange"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :auto-upload="false"
                multiple
                :limit="5"
              >
                <el-button type="primary" icon="el-icon-upload" plain
                  >选择附件</el-button
                >
              </el-upload>
              <div class="upload-tips">
                (单个文件不能超过50M，支持所有扩展名)
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="16" style="line-height: 40px"></el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate, sizeFormat } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";
import {
  getDictData,
  saveInsertQuestion,
  submitUpload,
  getDesignee,
} from "@/api/question.js";
import { getXmxxList } from "@/api/itWeekly";
import { fetchQuestionTx } from "@/api/common.js";
export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user", "question"]),
  },
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      rules: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        line: [
          {
            required: true,
            message: "所属条线不能为空",
            trigger: "change",
          },
        ],
        xmbh: [
          {
            required: true,
            message: "所属项目不能为空",
            trigger: "change",
          },
        ],
        sort: [
          { required: true, message: "问题类型不能为空", trigger: "change" },
        ],
        designee: [
          { required: true, message: "指派人不能为空", trigger: "change" },
        ],
        finishTime: [
          {
            required: true,
            message: "期望完成时间不能为空",
            trigger: "change",
          },
        ],
      },
      addForm: {
        line: null,
        xmbh: null,
        productVersion: null,
        title: null,
        sort: null,
        finishTime: moment().add(3, "d").format("YYYY-MM-DD"),
        planTime: null,
        designee: null,
        detail: null,
        jjfa: null,
        fileIds: null,
      },
      data2: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "0", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "0",
        //htzt: "1,2,3,4,5", //合同状态，多个,隔开，如1,3
      },
      bmShowFlag: false,
      txList: [],
      xmList: [],
      sortList: [],
      sortList2: [],
      bmList: [],
      parentDialog: false,
      fileList: [],
      isDisable: false,
      fullscreenLoading: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    fetchQuestionTx().then((res) => {
      if (res.code == 0) {
        this.txList = res.data;
      }
    });
    getXmxxList(
      this.data2.htlx,
      this.data2.range,
      this.data2.htzt,
      "",
      ""
    ).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
    getDictData("pmp_quality_sort", 1).then((res) => {
      if (res.code === 0) {
        this.sortList = res.data;
        this.sortList2 = res.data;
      }
    });
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor`);
    let editor2 = new wangEditor(`#wangEditor2`);
    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    // 创建编辑器
    this.editor = editor;
    this.editor2 = editor2;
  },
  methods: {
    handleChangeTx(i) {
      if (i == 1 || i == 2 || i == 4 || i == 16 || i == 14) {
        this.bmShowFlag = true;
      } else {
        this.bmShowFlag = false;
      }
      if (i == 1 || i == 2 || i == 4 || i == 14) {
        this.sortList = this.sortList2.filter((o) => o.dictValue > 20);
        if (this.addForm.sort < 20) {
          this.addForm.sort = null;
        }
      } else {
        this.sortList = this.sortList2.filter((o) => o.dictValue < 20);
        if (this.addForm.sort > 20) {
          this.addForm.sort = null;
        }
      }
      this.addForm.xmbh = null;
      getDesignee({
        line: i,
        xmbh: this.addForm.xmbh ? this.addForm.xmbh : "",
      }).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.addForm.designee = res.data;
          } else {
            this.addForm.designee = null;
          }
        }
      });
    },
    handleChangeBm(i) {
      getDesignee({ line: this.addForm.line, xmbh: i }).then((res) => {
        if (res.code == 0) {
          this.addForm.designee = res.data;
        }
      });
    },
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },
    saveForm() {
      let finishTime = null;
      if (this.addForm.finishTime) {
        finishTime = formatMomentDate(new Date(this.addForm.finishTime));
      }

      const params = {
        ...this.addForm,
        finishTime,
      };
      saveInsertQuestion(params).then((res) => {
        if (res.code == 0) {
          this.$store.dispatch(
            "question/fetchQuestionListAction",
            this.question.questionList.params
          );
          this.$emit("giveFather", this.parentDialog);
          this.$message.success(res.msg);
          this.isDisable = false;
          this.fullscreenLoading = false;
        } else {
          this.$message.error(res.msg);
          return false;
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
    resetFrom() {
      const { tx, bmbh } = this.user;
      this.addForm = {
        rwTxlx: tx,
        rwBmbh: bmbh,
        rwName: null,
        rwSun: null,
        id: null,
        typeId: null,
        jf: null,
        title: null,
        rldx: 1,
        ygbhs: null,
        bmbhs: null,
        txlxs: null,
        rwsm: null,
        yqjg: null,
        jsrq: null,
        gs: 0,
        rwmb: null,
        status: null,
        bz: null,
      };
      this.fileList = [];
      this.editor.txt.html("");
      this.editor2.txt.html("");
      this.form.rldxActive = 0;
    },
    handleChange(file, fileList) {
      //验证上传文件的格式
      // const suffixReg = /(xls|xlsx|pdf|doc|docx|ppt|pptx)$/;
      // const point = file.name.lastIndexOf(".");
      // const suffix = file.name.substr(point + 1);
      // const isFile = suffixReg.test(suffix);
      // if (!isFile) {
      //   this.$message.error("请上传正确格式的文件 !");
      //   fileList.pop();
      //   return false;
      // }

      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
      //验证上传文件重复
      // let existFile = fileList
      //   .slice(0, fileList.length - 1)
      //   .find((f) => f.name === file.name);
      // if (existFile) {
      //   this.$message.error("当前文件已经存在!");
      //   fileList.pop();
      //   return false;
      // }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    submitUpload(status) {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          if (this.isDisable) {
            return;
          }
          this.isDisable = true;
          this.addForm.detail = this.editor.txt.html();
          this.addForm.jjfa = this.editor2.txt.html();
          if (!this.addForm.line) {
            this.$message.error("请选择所属条线！");
            return;
          }
          if (!this.addForm.sort) {
            this.$message.error("请选择问题类型！");
            return;
          }
          if (!this.addForm.title) {
            this.$message.error("请输入标题名称！");
            return;
          }
          if (!this.addForm.detail) {
            this.$message.error("请输入详细描述！");
            return;
          }
          this.$refs.upload.submit();
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });
          this.fullscreenLoading = true;

          if (fileLen > 0) {
            //上传文件
            form.append("type", "激活");
            return new Promise((resolve, reject) => {
              submitUpload(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {
              if (success.code == 0) {
                this.addForm.fileIds = success.data;
                this.saveForm();
              }
            });
          } else if (fileLen == 0) {
            this.saveForm();
          } else {
            this.$message.error(res.msg);
            return false;
          }
        } else {
          this.$message.error("请填写表单必填项再保存！");
          return false;
        }
      });
    },
    handleDeleteFile(row) {
      deleteFile({ fileId: row.fileId, path: row.url }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDownloadFile(row) {
      const filePath = row.absolutepath;
      const fileName = row.filename;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    getJfNum() {
      const { rwTxlx, rwBmbh, rwName, rwSun } = this.addForm;
      if (!rwTxlx || !rwBmbh || !rwName) {
        return;
      }
      getJf({ rwTxlx, rwBmbh, rwName, rwSun }).then((res) => {
        if (res.code == 0) {
          this.addForm.jf = res.data;
        }
      });
    },
    handleChangeSun(e) {
      this.addForm.rwSun = e;
      this.getJfNum();
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
.upload-tips {
  position: absolute;
  top: 0px;
  left: 140px;
}
</style>